import React, { Component } from 'react'
import { connect } from 'react-redux'

import Divider from 'material-ui/Divider'
import TextField from 'material-ui/TextField'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import Moment from 'moment'

import dataActions from 'actions/dataActions'
import { doc, dirtyRead } from 'selectors/common'
import InputMoney from 'components/InputMoney'
import PropertyCombobox from './PropertyCombobox'
import TenantCombobox from './TenantCombobox'
import BreakDatePicker from './BreakDatePicker'
import BreakDateTill from './BreakDateTill'
import Ledger from './Ledger'
import Terms from './Terms'

let select = dirtyRead(
	(state, props) => ({
		lease: doc(state, props.objectID),
		mode: state.mode
	})
)

export class LeftSide extends Component{
	render(){
		let { props } = this
		return(
			<div
				className="wrapper"
				style={{
					 width: (props.colspan>1)?"50%":"100%"
   				   , overflowY: (props.colspan>1)?"scroll":"hidden"
				   , overflowX: "hidden"
				}}
			>
				<div style={{width: "100%", padding:"10px 0px", boxShadow:props.expanded?"0px 2px 1px rgba(0,0,0,0.3)":"0px 1px 1px rgba(0,0,0,0.3)", backgroundColor: "white"}}>
					{!props.lease.breakDate && <div style={{width:"110px", float:"right", textAlign:"right", paddingRight:"20px", marginTop:"8px"}}>
						<span
							style={{
								cursor: "pointer"
							  , color: "red"
							}}
							onClick={()=>{
								this.props.STAGE({
									_id: props.objectID
								  , breakDate: Moment(new Date()).format("YYYY-MM-DD")
								  , breakDateTill: Moment().endOf("month").format("YYYY-MM-DD")
								})
							}}
						>
						   <svg
								width="18px"
								height="25px"
								viewBox="0 0 24 24"
								version="1.1"
								xmlns="http://www.w3.org/2000/svg"
								xmlnsXlink="http://www.w3.org/1999/xlink"
								style={{
									verticalAlign: "middle"
								  , marginRight: "4px"
								  , marginTop: "-2px"
								}}
							>
								<g transform="rotate(-48.030906677246094 12.000000000000004,12) " stroke="red" fill="none" id="Page-1">
									<g id="Page-1" stroke={"red"} strokeWidth="2" fill="none" fillRule="evenodd">
										<g id="Group-2" transform="translate(1.000000, 1.000000)" stroke={"red"} strokeWidth="2">
											<path d="M11,4.5 L11,17.5" id="Line" strokeLinecap="square"></path>
											<path d="M5,11 L17,11" id="Line" strokeLinecap="square"></path>
											<circle id="Oval-1" cx="11" cy="11" r="11"></circle>
										</g>
									</g>
								</g>
							</svg>
							<span style={{borderBottom: "dotted 2px rgb(240, 100, 100)"}}>BREAK</span>
						</span>
					</div>}
					<div style={{paddingLeft:"20px"}}>
						<PropertyCombobox objectID={props.objectID}/>
						<TenantCombobox objectID={props.objectID}/>
						{props.mode === 'creating' && <TextField
							floatingLabelText="Rent"
							defaultValue={props.lease.rent}
							style={{
								width: "100%",
								marginTop: "-20px",
								marginLeft: "38px"
							}}
							underlineStyle={{borderBottom: "0px solid"}}
							key={props.lease.rent}
							onBlur={(evt)=>
								this.props.STAGE({
									_id: props.objectID
									, rent: evt.target.value
								})
							}
						/>}
					</div>
					{props.lease.breakDate && <div style={{width: "100%", paddingLeft:"20px", paddingTop:"10px"}}>
						<BreakDatePicker objectID={props.objectID} />
						<BreakDateTill objectID={props.objectID} />
						<i
							className="material-icons"
							style={{
								height: "16px",
								cursor: "pointer",
								float: "right",
								marginRight:"17px",
								position: "relative",
								top: "20px",
								color: "grey",
								fontSize: "24px"
							}}
							onClick={() => {
								this.props.STAGE({
									_id: props.objectID
								  , breakDate: undefined
								  , breakDateTill: undefined
								})
							}}
						>
							close
						</i>
					</div>}
				</div>
				<Terms objectID={props.objectID} />
				<Ledger tenantID={props.lease.tenantID} lease={props.lease} width={props.width}/>
			</div>
		)
	}
}

export default connect(select, dataActions)(LeftSide)



// WEBPACK FOOTER //
// ./src/routes/manager/leaseForm/LeftSide.js